/*
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-titulacion-lista',
  templateUrl: './lista.component.html',
  styles: [
  ]
})
export class ListaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
*/

import { Component, OnInit } from '@angular/core';
import { JwtRequestService } from '../../../jwt-request.service';

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';

import * as jspdf from 'jspdf';

import { saveAs } from "file-saver";

@Component({
  selector: 'app-titulacion-lista',
  templateUrl: './lista.component.html',
  styleUrls: ['./lista.component.css']
})
//export class ListaTramitesComponent implements OnInit {
export class ListaComponent implements OnInit {

  // Variables globales para paginación y búsqueda
  buscar: boolean = false;
  valor: string = '';
  pagina: number = 0;
  limite: number = 25;
  columna: string = "id";

  // Variables del componente
  campo_buscar: string = '';
  tramitesLista: any[] = [];
  isLoading: boolean = false;
  showLoadingOverlay: boolean = false;
  
  // Variables para modales
  showXmlModal: boolean = false;
  showAutenticacionModal: boolean = false;
  xmlContent: string = '';
  itemSeleccionado: any = null;

  // Agrega estas variables después de las existentes
  showFirmarModal = false;
  contrasenia_firma = '************';
  itemAFirmar: any = null; 

  // Agrega estas variables después de las existentes
  showRegistrarModal = false;
  itemARegistrar: any = null;
  errorRegistro = '';

  // Agrega estas variables después de las existentes
  showConsultarModal = false;
  itemAConsultar: any = null;
  errorConsulta = '';

  showDetallesModal = false;
  itemADetallar: any = null;

  showCancelarModal = false;
  itemACancelar: any = null;
  id_motivo_cancelacion: string = '';
  texto_confirm: string = '';
  contrasenia_firma_cancelar: string = '';
  motivosCancelacion = [
    { value: 'R1', label: 'R1 - REASIGNACIÓN PARA LA CONCORDANCIA SEXO-GENÉRICA' },
    { value: 'R2', label: 'R2 - RECONOCIMIENTO DE PATERNIDAD' },
    { value: 'R3', label: 'R3 - CAMBIO Y MODIFICACIÓN AL NOMBRE' },
    { value: 'R4', label: 'R4 - CASO FORTUITO O FUERZA MAYOR' },
    { value: 'R5', label: 'R5 - OTRO' },
    { value: 'C1', label: 'C1 - CAUSA IMPUTABLE AL PROFESIONISTA' }
  ];


  showConstanciaModal = false;
  constanciaContent: any = null;


  constructor(private jwtRequest: JwtRequestService) {}

  ngOnInit(): void {

    this.campo_buscar = '';
    this.cargarTramitesInicial();
    this.campo_buscar = '';

  }

// Carga inicial de trámites - CORREGIDA
cargarTramitesInicial(): void {
  this.buscar = false;
  this.valor = '';
  this.pagina = 0;
  this.limite = 25;
  this.obtenerTramites();
}



// Función para abrir modal de detalles
abrirModalDetalles(item: any): void {
  this.itemADetallar = {...item};
  this.showDetallesModal = true;
}

// Función para cerrar modal de detalles
cerrarModalDetalles(): void {
  this.showDetallesModal = false;
  this.itemADetallar = null;
}


// Agrega estas funciones después de las existentes
// Función para abrir modal de firma
abrirModalFirmar(item: any): void {
  this.itemAFirmar = item;
  this.contrasenia_firma = '';
  this.showFirmarModal = true;
}

// Función para cerrar modal de firma
cerrarModalFirmar(): void {
  this.showFirmarModal = false;
  this.itemAFirmar = null;
  this.contrasenia_firma = '';
}

// Función para firmar título
firmarTitulo(): void {
 // return;
  if (!this.itemAFirmar || !this.contrasenia_firma.trim()) {
    alert('Por favor ingrese la contraseña de firma');
    return;
  }

  if (confirm('¿Desea Firmar este Título?')) {
    this.isLoading = true;
    this.showLoadingOverlay = true;

    const datosFirma = {
      id: this.itemAFirmar.id,
      contrasenia_firma: this.contrasenia_firma.trim()
    };

    this.jwtRequest.post('firmar-titulo', datosFirma)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          
          if (response.status === 201) {
            // Cerrar modal y recargar listado
            this.cerrarModalFirmar();
            this.cargarTramitesInicial();
          } else {
            alert(response.messages || 'Error al firmar el título');
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          if (error.error && error.error.messages) {
            alert(error.error.messages);
          } else {
            alert('Error de conexión al firmar el título');
          }
        }
      });
  }
}






// Función para abrir modal de consulta
abrirModalConsultar(item: any): void {
  this.itemAConsultar = {...item}; // Copia del item para mostrar en el modal
  this.errorConsulta = '';
  this.showConsultarModal = true;
}

// Función para cerrar modal de consulta
cerrarModalConsultar(): void {
  this.showConsultarModal = false;
  this.itemAConsultar = null;
  this.errorConsulta = '';
  // Recargar listado al cerrar el modal
  this.cargarTramitesInicial();
}

// Función para consultar título
consultarTitulo(): void {
  //return;
  if (!this.itemAConsultar) {
    return;
  }

  if (confirm('¿Desea Consultar este Título?')) {
    this.isLoading = true;
    this.showLoadingOverlay = true;
    this.errorConsulta = '';

    const datosConsulta = {
      id: this.itemAConsultar.id
    };

    this.jwtRequest.post('consultar-titulo', datosConsulta)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          
          if (response.status === 200) {
            // Actualizar los datos en el modal con la respuesta
            if (response.data) {
              this.itemAConsultar = {
                ...this.itemAConsultar,
                ...response.data
              };
            }
          } else {
            this.errorConsulta = response.messages || 'Error al consultar el título';
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          if (error.error && error.error.messages) {
            this.errorConsulta = error.error.messages;
          } else {
            this.errorConsulta = 'Error de conexión al consultar el título';
          }
        }
      });
  }
}








// Función para abrir modal de registro
abrirModalRegistrar(item: any): void {
  this.itemARegistrar = item;
  this.errorRegistro = '';
  this.showRegistrarModal = true;
}

// Función para cerrar modal de registro
cerrarModalRegistrar(): void {
  this.showRegistrarModal = false;
  this.itemARegistrar = null;
  this.errorRegistro = '';
}

// Función para registrar título
registrarTitulo(): void {
  //return;
  if (!this.itemARegistrar) {
    return;
  }

  if (confirm('¿Desea Registrar este Título?')) {
   // return;
    this.isLoading = true;
    this.showLoadingOverlay = true;
    this.errorRegistro = '';

    const datosRegistro = {
      id: this.itemARegistrar.id
    };

    this.jwtRequest.post('registrar-titulo', datosRegistro)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          
          if (response.status === 201) {
            // Cerrar modal y recargar listado
            this.cerrarModalRegistrar();
            this.cargarTramitesInicial();
          } else {
            this.errorRegistro = response.messages || 'Error al registrar el título';
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          if (error.error && error.error.messages) {
            this.errorRegistro = error.error.messages;
          } else {
            this.errorRegistro = 'Error de conexión al registrar el título';
          }
        }
      });
  }
}





// Función para abrir modal de cancelación
abrirModalCancelar(item: any): void {
  this.itemACancelar = {...item};
  this.id_motivo_cancelacion = '';
  this.texto_confirm = '';
  this.contrasenia_firma_cancelar = '';
  this.showCancelarModal = true;
}

// Función para cerrar modal de cancelación
cerrarModalCancelar(): void {
  this.showCancelarModal = false;
  this.itemACancelar = null;
  this.id_motivo_cancelacion = '';
  this.texto_confirm = '';
  this.contrasenia_firma_cancelar = '';
  // Recargar listado al cerrar el modal
  this.cargarTramitesInicial();
}

// Función para cancelar título
cancelarTitulo(): void {
  if (!this.itemACancelar) {
    return;
  }

  // Validaciones
  if (!this.id_motivo_cancelacion) {
    alert('Por favor seleccione un motivo de cancelación');
    return;
  }

  if (this.texto_confirm !== 'CANCELAR TITULO') {
    alert('Por favor escriba exactamente la frase: CANCELAR TITULO');
    return;
  }

  if (!this.contrasenia_firma_cancelar.trim()) {
    alert('Por favor ingrese la contraseña de firma');
    return;
  }

  if (confirm('¿Está seguro de que desea cancelar este título?')) {
    this.isLoading = true;
    this.showLoadingOverlay = true;

    const datosCancelacion = {
      id: this.itemACancelar.id,
      id_motivo_cancelacion: this.id_motivo_cancelacion,
      texto_confirm: this.texto_confirm,
      contrasenia_firma: this.contrasenia_firma_cancelar.trim()
    };

    this.jwtRequest.post('cancelar-titulo-electronico', datosCancelacion)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          
          if (response.status === 201) {
            // Actualizar el atributo cancelado en el modal
            this.itemACancelar.cancelado = 1;
            alert('Título cancelado exitosamente');
          } else {
            alert(response.messages || 'Error al cancelar el título');
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          if (error.error && error.error.messages) {
            alert(error.error.messages);
          } else {
            alert('Error de conexión al cancelar el título');
          }
        }
      });
  }
}





// Función para buscar trámites (enter en input) - CORREGIDA
buscarTramites(): void {
  if (this.campo_buscar && this.campo_buscar.trim()) {
    this.buscar = true;
    this.valor = this.campo_buscar.trim();
    this.pagina = 0;
  } else {
    this.buscar = false;
    this.valor = '';
    this.pagina = 0;
  }
  this.obtenerTramites();
}


// Función para actualizar listado (botón refresh) - CORREGIDA
actualizarListado(): void {
  if (this.campo_buscar && this.campo_buscar.trim()) {
    this.buscar = true;
    this.valor = this.campo_buscar.trim();
  } else {
    this.buscar = false;
    this.valor = '';
  }
  this.pagina = 0;
  this.obtenerTramites();
}


// Obtener trámites desde la API - ALTERNATIVA
obtenerTramites(): void {
  this.isLoading = true;
  this.showLoadingOverlay = true;

  // Construir query string manualmente
  const queryParams = new URLSearchParams();
  queryParams.append('buscar', this.buscar.toString());
  queryParams.append('valor', this.valor);
  queryParams.append('pagina', this.pagina.toString());
  queryParams.append('limite', this.limite.toString());
  queryParams.append('columna', this.columna.toString());

  const url = `tramite-titulo?${queryParams.toString()}`;
  
  console.log('URL completa:', url); // Para debug

  this.jwtRequest.get(url)
    .subscribe({
      next: (response: any) => {
        this.isLoading = false;
        this.showLoadingOverlay = false;
        
        if (response.status === 200) {
          this.tramitesLista = response.data || [];
        } else {
          console.error('Error al cargar trámites:', response.messages);
          this.tramitesLista = [];
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.showLoadingOverlay = false;
        console.error('Error de conexión:', error);
        this.tramitesLista = [];
      }
    });
}



  // Modal XML
  verXML(item: any): void {
    this.itemSeleccionado = item;
    this.xmlContent = item.xml || '';
    this.showXmlModal = true;
  }

  cerrarModalXml(): void {
    this.showXmlModal = false;
    this.xmlContent = '';
    this.itemSeleccionado = null;
  }

  descargarXml(): void {
     //   return;
    if (this.xmlContent && this.itemSeleccionado) {
      const blob = new Blob([this.xmlContent], { type: 'application/xml' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${this.itemSeleccionado.folioControl || 'tramite'}.xml`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  }

  // Modal Autenticación
  abrirModalAutenticacion(item: any): void {
    this.itemSeleccionado = item;
    this.showAutenticacionModal = true;
  }

  cerrarModalAutenticacion(): void {
    this.showAutenticacionModal = false;
    this.itemSeleccionado = null;
  }

  consultarStatus(item: any): void {
    if (!item) return;
    
    this.isLoading = true;
    this.showLoadingOverlay = true;

    // Aquí implementarías la lógica para consultar el status
    // Por ahora solo simulamos una llamada
    setTimeout(() => {
      this.isLoading = false;
      this.showLoadingOverlay = false;
      console.log('Consultando status para:', item.folioControl);
      // Aquí actualizarías los datos del item con la respuesta
    }, 1000);
  }


  // Función auxiliar para las clases del estatus lote
getEstatusLoteClass(estatus: string): string {
  if (estatus === '1') {
    return 'estatus-procesado';
  }
  return 'estatus-normal';
}



// Agrega esta función después de las otras funciones existentes
// Función para descargar lote de título
descargarLoteTitulo(item: any): void {
  if (!item || !item.numeroLote) {
    alert('No se puede descargar el lote: número de lote no disponible');
    return;
  }

  if (confirm('¿Desea descargar el lote de título?')) {
    this.isLoading = true;
    this.showLoadingOverlay = true;

    const datosDescarga = {
      id: item.id,
      numeroLote: item.numeroLote
    };

    this.jwtRequest.post('descargar-lote-titulo', datosDescarga)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          
          if (response.status === 200 && response.loteZip) {
            try {   
              // Decodificar base64 a blob
              const base64Data = response.loteZip;
              const binaryString = atob(base64Data);
              const bytes = new Uint8Array(binaryString.length);
              
              for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
              }
              
              const blob = new Blob([bytes], { type: 'application/zip' });
              
              // Crear enlace de descarga
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
             // a.download = `${item.numeroLote}.zip`;
              a.download = item.curpProfesionista+'_'+'_'+item.folioControl+'_'+item.numeroLote+'.zip';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              
              //alert('Descarga completada exitosamente');
              
            } catch (error) {
              console.error('Error al decodificar el archivo:', error);
              alert('Error al procesar el archivo de descarga');
            }
          } else {
            alert(response.error || 'Error en la respuesta del servidor');
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          if (error.error && error.error.error) {
            alert(error.error.error);
          } else {
            alert('Error de conexión al descargar el lote de título');
          }
        }
      });
  }
}






getBase64Image(path: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = path;

    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext('2d');
      ctx!.drawImage(img, 0, 0);

      const dataURL = canvas.toDataURL('image/png');
      resolve(dataURL);
    };

    img.onerror = err => reject(err);
  });
}


async generarTitulo(item: any) {
  const bg = await this.getBase64Image('assets/marco-titulo.png');
  this.generaTituloPDF(item, bg);   // tu función recibe el base64
}

// jsPDF 1.5.3 - Generador de Título Electrónico SEP
// Ajustado según nuevas instrucciones

 generaTituloPDF(item,bg) {
  const doc = new jsPDF({ unit: 'pt', format: 'letter' });

  // === Margen general ===
  //const M = 20;
  const M = 36;
  const pageWidth = 612;
  const contentWidth = pageWidth - M * 2;

  // === Fondo ===
  //const background = '../../ts/marco-titulo.png';
  doc.addImage(bg, 'PNG', 0, 0, 612, 792);

  // === Utilidades ===
  const font = 'helvetica';
  const lineHeight = 16; // fila
  let y = M + lineHeight * 3; // Inicio en fila 6

  const text = (txt, x, size = 10, weight = 'normal') => {
    doc.setFont(font, weight);
    doc.setFontSize(size);
    doc.text(txt, x, y);
  };

  // === Encabezado Izquierdo ===
  doc.setFont(font, 'bold');
  doc.setFontSize(12);
  const leftX = M;
  const leftWidth = contentWidth * (2 / 3);

  doc.text('Estados Unidos Mexicanos', leftX, y);
  y += lineHeight;
  doc.text('Secretaría de Educación Pública', leftX, y);
  y += lineHeight;
  doc.text('Dirección General de Profesiones', leftX, y);
  y += lineHeight;
  doc.text('Constancia de Registro del Título Electrónico', leftX, y);

  // === Bloque Derecho ===
  let rightY = M + lineHeight * 1; // fila 4
  const rightX = M + leftWidth + 10;

  // CURP
  doc.setFont(font, 'normal');
  doc.setFontSize(10);
  doc.text('Clave Única de Registro de Población', rightX, rightY);
  rightY += lineHeight;

  doc.setFont(font, 'bold');
  doc.setFontSize(11);
  doc.text(String(item.curpProfesionista).toUpperCase(), rightX, rightY);
  rightY += lineHeight * 2;

  // Folio Registro
  doc.setFont(font, 'normal');
  doc.setFontSize(10);
  doc.text('Folio de Registro', rightX, rightY);
  rightY += lineHeight;

  doc.setFont(font, 'bold');
  doc.setFontSize(11);
  doc.text(item.folioControl + ' - ' + item.numeroLote, rightX, rightY);

  // === Etiqueta Datos del profesionista ===
  y += lineHeight * 2;
  const cardColor = '#E8E8E8';
  const labelHeight = 22;

  doc.setFillColor(cardColor);
  doc.rect(leftX, y - labelHeight + 5, contentWidth, labelHeight, 'F');

  doc.setFont(font, 'bold');
  doc.setFontSize(11);
  doc.text('Datos del profesionista', leftX + contentWidth / 2, y, { align: 'center' });

  // === Nombres ===
  y += lineHeight * 2;
  const colWidth = contentWidth / 3;
  const col1 = leftX + colWidth / 2;
  const col2 = leftX + colWidth * 1.5;
  const col3 = leftX + colWidth * 2.5;

  doc.setFont(font, 'normal');
  doc.setFontSize(12);
  doc.text(item.nombreProfesionista, col1, y, { align: 'center' });
  doc.text(item.primerApellidoProfesionista, col2, y, { align: 'center' });
  doc.text(item.segundoApellidoProfesionista, col3, y, { align: 'center' });

  // Línea debajo
  y += 5;
  doc.setDrawColor(cardColor);
  doc.setLineWidth(1);
  doc.line(leftX, y, leftX + contentWidth, y);

  // Etiquetas
  y += lineHeight;
  doc.setFontSize(10);
  doc.text('Nombre(s)', col1, y, { align: 'center' });
  doc.text('Primer Apellido', col2, y, { align: 'center' });
  doc.text('Segundo Apellido', col3, y, { align: 'center' });

  // === Datos de la institución ===
  y += lineHeight * 2;
  doc.setFillColor(cardColor);
  doc.rect(leftX, y - labelHeight + 5, contentWidth, labelHeight, 'F');

  doc.setFont(font, 'bold');
  doc.setFontSize(11);
  doc.text('Datos de la Institución', leftX + contentWidth / 2, y, { align: 'center' });

  // valor institución
  y += lineHeight * 1.5;
  doc.setFont(font, 'normal');
  doc.setFontSize(12);
  doc.text(item.nombreInstitucion, leftX + contentWidth / 2, y, { align: 'center' });

  // Línea
  y += 5;
  doc.setDrawColor(cardColor);
  doc.setLineWidth(1);
  doc.line(leftX, y, leftX + contentWidth, y);

  // Etiqueta nombre
  y += lineHeight;
  doc.setFontSize(10);
  //doc.text('Nombre', leftX, y);
  doc.text('Nombre', leftX + contentWidth / 2, y, { align: 'center' });




  // valor rvoe
  y += lineHeight * 1.5;
  doc.setFont(font, 'normal');
  doc.setFontSize(12);
  doc.text(item.numeroRvoe.toString(), leftX + contentWidth / 2, y, { align: 'center' });

  // Línea
  y += 5;
  doc.setDrawColor(cardColor);
  doc.setLineWidth(1);
  doc.line(leftX, y, leftX + contentWidth, y);

  // Etiqueta rvoe
  y += lineHeight;
  doc.setFontSize(10);
  //doc.text('Nombre', leftX, y);
  doc.text('Número del Acuerdo de Reconocimiento de Validez Oficial de Estudios (RVOE)', leftX + contentWidth / 2, y, { align: 'center' });



  // === Datos de la institución ===
  y += lineHeight * 2;
  doc.setFillColor(cardColor);
  doc.rect(leftX, y - labelHeight + 5, contentWidth, labelHeight, 'F');

  doc.setFont(font, 'bold');
  doc.setFontSize(11);
  doc.text('Lugar y fecha de Expedición', leftX + contentWidth / 2, y, { align: 'center' });





  // === Nombre archivo ===
  const nombreArchivo = `${item.curpProfesionista}_${item.folioControl}_${item.numeroLote}.pdf`;
  doc.save(nombreArchivo);
}






// jsPDF 1.5.3 - Generador de Título Electrónico SEP
// Fondo ubicado en: src/assets/marco-titulo.png
// Esta función replica la distribución del ejemplo proporcionado.

generaTituloPDF1(item) {
  const doc = new jsPDF({ unit: 'pt', format: 'letter' });

  // === Fondo ===
  const background = 'assets/marco-titulo.png';
  //doc.addImage(background, 'PNG', 0, 0, 612, 792);

  // === Utilidades ===
  const font = 'helvetica';
  const sizeTitle = 12;
  const sizeText = 9;
  const line = (y, txt, x = 60) => { doc.text(txt, x, y); };

  // === Encabezado ===
  doc.setFont(font, 'bold');
  doc.setFontSize(14);
  line(85, 'Estados Unidos Mexicanos', 180);
  line(105, 'Secretaría de Educación Pública', 165);
  line(125, 'Dirección General de Acreditación, Incorporación y Revalidación', 85);
  line(145, 'Constancia de Autenticación del Título Electrónico', 110);

  // === Código de barras usando imgData ===
  let imgData = 'data:image/jpeg;base64,' + item.curpProfesionista;
  //doc.addImage(imgData, 'JPEG', 420, 155, 150, 40);

  // === CURP ===
  doc.setFont(font, 'normal');
  doc.setFontSize(sizeText);
  line(210, 'CURP del profesionista: ' + item.curpProfesionista, 420);

  // === Datos del profesionista ===
  doc.setFont(font, 'bold');
  line(185, 'Datos del profesionista');

  doc.setFont(font, 'normal');
  line(205, item.nombreProfesionista + ' ' + item.primerApellidoProfesionista + ' ' + item.segundoApellidoProfesionista);
  line(225, 'Carrera: ' + item.nombreCarrera);
  line(245, 'Clave Carrera: ' + item.cveCarrera);

  // === Datos de la institución ===
  doc.setFont(font, 'bold');
  line(285, 'Datos de la institución');
  doc.setFont(font, 'normal');
  line(305, item.nombreInstitucion);
  line(325, 'RVOE: ' + item.numeroRvoe);

  // === Lugar y fecha ===
  doc.setFont(font, 'bold');
  line(365, 'Lugar y Fecha de Expedición');
  doc.setFont(font, 'normal');
  line(385, item.entidadFederativaExpedicion + ' — ' + item.fechaExpedicion);

  // === Responsable ===
  doc.setFont(font, 'bold');
  line(425, 'Responsable de la institución');
  doc.setFont(font, 'normal');
  line(445, item.nombreResponsable + ' ' + item.primerApellidoResponsable + ' ' + item.segundoApellidoResponsable);
  line(465, 'Cargo: ' + item.cargo);

  // === Firma electrónica ===
  doc.setFont(font, 'bold');
  line(505, 'Firma electrónica de la autoridad educativa');
  doc.setFont(font, 'normal');
  line(525, 'Sello Digital');
  line(545, item.cadenaOriginal.substring(0, 95));
  line(560, item.cadenaOriginal.substring(95, 190));
  line(575, item.cadenaOriginal.substring(190, 285));

  // === QR (reservado) ===
  // doc.addImage('qr.png','PNG',60,600,90,90);

  // === Leyendas ===
  doc.setFontSize(7);
  line(600, 'La presente constancia de autenticación... (párrafo completo aquí)', 170);
  line(620, 'Se expide como un registro fiel...');
  line(640, 'La integridad y autoría del presente documento...');

  // === Nombre archivo ===
  const nombreArchivo = `${item.curpProfesionista}_${item.folioControl}_${item.numeroLote}.pdf`;
  doc.save(nombreArchivo);
}












}